import React from "react";
import { appConfigService } from "services/appConfigService";

export const LocaleContext = React.createContext({
  language: appConfigService.getItem("lang"),
  setLanguage: (v: "vi" | "en") => {},
  locale: appConfigService.getItem("lang") === "vi" ? "vi-VN" : "en-US",
});
